import { createFileRoute } from '@tanstack/react-router';

import type { BalanceSheetId } from '@/../convex/types';
import { Dashboard } from '@/components/Dashboard';
import { AuthenticatedRoute } from '@/lib/authenticatedRoute';

function DashboardPage() {
  const { id } = Route.useParams() as { id: BalanceSheetId };
  return (
    <div className="p-4">
      <Dashboard id={id} />
    </div>
  );
}

export const Route = createFileRoute('/balance-sheet/$id/dashboard')({
  component: AuthenticatedRoute(DashboardPage),
});
